import * as React from 'react';
import "./KeyboardCustom.css";
import { KeyboardType } from '../../constants/keyboardTypes';
import { KEYS, NUMPAD, KEYS_NAM_ENTRY, SPECIAL_KEYS } from './Constants';
import KeyBoardKeysSymbolFactory, { KeyboardKey } from './KeyBoardKeysSymbolFactory';
interface IKioskKeyboardProps {
    value: string;
    show: boolean;
    keyboardType: KeyboardType;
    hide(): void;
    enter(): void;
    onChange(value: string): void;
}

export class KeyboardKiosk extends React.Component<IKioskKeyboardProps, any>  {
    constructor(props: Readonly<IKioskKeyboardProps>) {
        super(props);
        let keyboard: any;
        if (this.props.keyboardType === KeyboardType.STANDARD) {
            keyboard = KEYS;
        } else if (this.props.keyboardType === KeyboardType.NUMPAD) {
            keyboard = NUMPAD;
        } else if (this.props.keyboardType === KeyboardType.NO_SPECIALS_ALL_CAPS) {
            keyboard = KEYS_NAM_ENTRY;
        }
        this.state = {
            selected: "",
            currentKeyboard: keyboard,
            capLocked: false,
            shifted: false,
            lang: "ES",
            value: ""
        }
        this.onKeyDown = this.onKeyDown.bind(this);
        this.keySelectSwitch = this.keySelectSwitch.bind(this);
    }
    public componentWillReceiveProps(nextProps: IKioskKeyboardProps) {
        if (nextProps.onChange !== this.props.onChange) {
            let keyboard: any;
            if (nextProps.keyboardType === KeyboardType.STANDARD) {
                keyboard = KEYS;
            } else if (nextProps.keyboardType === KeyboardType.NUMPAD) {
                keyboard = NUMPAD;
            } else if (nextProps.keyboardType === KeyboardType.NO_SPECIALS_ALL_CAPS) {
                keyboard = KEYS_NAM_ENTRY;
            }
            this.setState({ value: nextProps.value, currentKeyboard: keyboard });
        } else if (nextProps.value.length === 0) {
            this.setState({ value: "", currentKeyboard: KEYS });
        }
    }

    public getIconForKey(key: string): JSX.Element {
        const keyString = "keyboard-button-" + key;
        switch (key) {
            case "{backspace}":
                return <span id={keyString} style={{ fontSize: "30px" }}><i className="fas fa-backspace" id={keyString + "-fas"} /></span>;
            case "{shift}":
                return <span id={keyString} style={{ fontSize: "30px" }}><i className="fas fa-arrow-up" id={keyString + "-fas"} /></span>;
            case "{space}":
                return KeyBoardKeysSymbolFactory.GenerateKey(KeyboardKey.Space, keyString);
            case "{enter}":
                return KeyBoardKeysSymbolFactory.GenerateKey(KeyboardKey.Enter, keyString);
            case "{tab}":
                return KeyBoardKeysSymbolFactory.GenerateKey(KeyboardKey.Tab, keyString);
            case "{caps}":
                return KeyBoardKeysSymbolFactory.GenerateKey(KeyboardKey.Caps, keyString);
            case "{hideKeyboard}":
                return KeyBoardKeysSymbolFactory.GenerateKey(KeyboardKey.HideKeyboard, keyString);
            case "{lang}":
                return KeyBoardKeysSymbolFactory.GenerateKey(KeyboardKey.LanguageSwitch, keyString);
            case "{specialChar}":
                return <span id={keyString}>!¿é</span>;
            case "{ABC}":
                return <span id={keyString}>ABC</span>;
            default:
                if (this.state.capLocked || this.state.shifted) {
                    return <span id={keyString}>{key.toUpperCase()}</span>;
                } else {
                    return <span id={keyString}>{key}</span>;
                }
        }
    }

    public keySelectSwitch(key: string) {
        switch (key) {
            case '{lang}':
                if (this.state.lang === "FR") {
                    this.setState({ lang: "ES" });
                } else {
                    this.setState({ lang: "FR" });
                }
                break;
            case '{shift}':
                if (this.state.shifted && !this.state.capLocked) {
                    this.setState({ capLocked: true });
                } else if (this.state.shifted && this.state.capLocked) {
                    this.setState({ shifted: false, capLocked: false })
                } else {
                    this.setState({ shifted: true, capLocked: false });
                }
                break;
            case '{backspace}':
                const value: string = this.state.value;
                if (value.length >= 1) {
                    this.setState({ value: value.substring(0, value.length - 1) }, () => { this.props.onChange(this.state.value) });
                }
                break;
            case '{enter}':
                this.props.enter();
                break;
            case '{hideKeyboard}':
                this.props.hide();
                break;
            case '{space}':
                this.props.onChange(this.props.value + " ");
            case '{specialChar}':
                this.setState({ currentKeyboard: SPECIAL_KEYS });
                break;
            case '{ABC}':
                this.setState({ currentKeyboard: KEYS });
                break;
            default:
                if (!key.includes('{') && !key.includes('}')) {
                    let charToAdd: string;
                    if (this.state.shifted || this.state.capLocked) {
                        charToAdd = key.toUpperCase().toString();
                    } else {
                        charToAdd = key.toString();
                    }
                    if (this.state.shifted && !this.state.capLocked) {
                        this.setState({ shifted: false }, () => { this.props.onChange(this.props.value + charToAdd) });
                    } else {
                        this.props.onChange(this.props.value + charToAdd);
                    }
                }
                break;
        }
    }
    public onKeyDown(key: string) {
        if (this.state.value.length === 0) {
            this.setState({ value: this.props.value }, () => {
                this.keySelectSwitch(key);
            })
            return
        }
        this.keySelectSwitch(key);
    }
    public renderButton(item: string, index: number): JSX.Element {
        let buttonClassName = "keyboard-button";
        if (item.includes('{') && item.includes('}')) {
            buttonClassName = buttonClassName + "-function " + item.substring(1, item.length - 1);
            if (this.state.selected === item) {
                buttonClassName = buttonClassName + " selected";
            }

            if (item === "{shift}") {
                if (this.state.shifted && !this.state.capLocked) {
                    buttonClassName = buttonClassName + " shifted";
                } else if (this.state.shifted && this.state.capLocked) {
                    buttonClassName = buttonClassName + " caplocked";
                }
            }

            if (this.props.keyboardType === KeyboardType.NUMPAD) {
                buttonClassName = buttonClassName + " numpad";
            }
            return (
                <div
                    id={"keyboard-button-" + index}
                    key={"keyboard-button-" + index}
                    className={buttonClassName}
                    onClick={(e) => e.stopPropagation()}
                    onTouchStart={() => { this.setState({ selected: item }) }}
                    onTouchEnd={() => { this.setState({ selected: "" }, () => { this.onKeyDown(item) }) }}
                >
                    {this.getIconForKey(item)}
                </div>
            );
        } else {
            buttonClassName = buttonClassName + "-std";

            if (this.props.keyboardType === KeyboardType.NUMPAD) {
                buttonClassName = buttonClassName + " numpad ";
                buttonClassName = (item === "0") ? buttonClassName + " zero" : buttonClassName;
            }

            if (this.state.selected === item) {
                buttonClassName = buttonClassName + " selected";
            }

            return (
                <div
                    key={"keyboard-button-" + index}
                    id={"keyboard-button-" + index}
                    className={buttonClassName}
                    onTouchStart={() => { this.setState({ selected: item }) }}
                    onTouchEnd={() => { this.setState({ selected: "" }, () => { this.onKeyDown(item) }) }}
                >
                    {this.getIconForKey(item)}
                </div>
            );
        }
    }
    public render() {
        const renderKeyboard = this.state.currentKeyboard;
        return (
            <div
                id={"keyboard-container"}
                className={"keyboard-container " + (this.props.show ? "keyboard-move" : "keyboard-stay")}
                style={{ width: this.props.keyboardType === KeyboardType.NUMPAD ? "500px" : "100%" }}
                onClick={e => e.stopPropagation()}
            >
                <div
                    id={"keyboard-sub-container"}
                    className="keyboard-sub-container"
                    style={{ maxWidth: renderKeyboard === NUMPAD ? "520px" : "1024px" }}
                >
                    <div id={"keyboard-key-container"} className="keyboard-key-container">
                        {
                            renderKeyboard.map((row, index) => {
                                return (
                                    <div id={"keyboard-row" + index} className="keyboard-row" key={"keyboard-row" + index}>
                                        {row.map((item, index2) => {
                                            return this.renderButton(item, index2);
                                        })}
                                    </div>
                                );
                            })
                        }
                    </div >
                </div >
            </div >
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/KeyboardKiosk/KeyboardKiosk.tsx